import { useGetEnginePlayMysession, usePostEnginePlayDelete } from '@/types/origin-point-engine'
import { logger } from '@/lib/logger'
import { useAuthStore } from '@/features/auth'

export const useSessions = () => {
  const {user} = useAuthStore(s=>s.auth)
  const { data: sessionList } = useGetEnginePlayMysession({
    query: {
      enabled: !!user,
      select: (data) => {
        const response = data.data
        return response
      },
      staleTime: 1000 * 5,
    },
  })

  const { mutateAsync: endSessionAsync } = usePostEnginePlayDelete({
      mutation: {
        onSuccess: (data) => {
          const response = data
          logger.debug('会话已结束')
          return response.data
        },
      },
    })

    return {
      sessionList,
      endSessionAsync,
    }
}
